var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"test"},[_c('ul',_vm._l((50),function(item){return _c('li',{directives:[{name:"lazy-container",rawName:"v-lazy-container",value:({ selector: 'img' }),expression:"{ selector: 'img' }"}],key:item,domProps:{"innerHTML":_vm._s(_vm.content)}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }